export default __webpack_public_path__ + "static/media/lostpass-complete.c4a96e88.svg";